/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const RemovedDropShadow = styled.div`
  & > div {
    box-shadow: none;
  }
`;
